import {
    useGetGroupsByChannelIdQuery,
    useGetGroupsBySiteIdQuery,
} from '@/shared/api'
import { useParams } from 'react-router'

export const useGroupNameChannels = ({ channelId }: { channelId: number }) => {
    const { groupId } = useParams<{ groupId: string }>()
    const numericGroupId = groupId ? Number(groupId) : 0
    const { data: groups } = useGetGroupsByChannelIdQuery(channelId)
    const groupName = groups?.find(
        (group) => group.invite_links_group_id === numericGroupId
    )?.group_name

    return groupName
}

export const useGroupNameSites = ({ siteId }: { siteId: number }) => {
    const { groupId } = useParams<{ groupId: string }>()
    const numericGroupId = groupId ? Number(groupId) : 0
    const { data: groups } = useGetGroupsBySiteIdQuery(siteId)
    const groupName = groups?.find(
        (group) => group.site_links_group_id === numericGroupId
    )?.group_name

    return groupName
}
